// extracted by mini-css-extract-plugin
module.exports = {"winnersContainer":"Winners_winnersContainer__2akfG"};